export default {"src":"/_next/static/media/music.e59d75e1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};